
import ToolHeader from "../../Components/ToolHeader";
import "../JSONTools/JSONformatter.css";
import { Row, Col } from "react-bootstrap";
import "./ImagePdfTools.css";
import { useState, useRef } from "react";

import { ReactComponent as DeleteIcon } from "../../Icons/Delete.svg";
import { PdftoImageAPI, ImagetoPDFAPI } from "../../Services/APIService";
import { Download } from "lucide-react";

const FORMAT_OPTIONS = [
    "Image ➜ PDF",
    "PDF ➜ Image",
];
const IMAGE_FORMATS = [
    "PNG",
    "JPG"
];

function PDFImageConverter() {
    const [selectedFormat, setSelectedFormat] = useState("Image ➜ PDF");

    // BASE64 ➜ IMAGE
    const [pdfImages, setPdfImages] = useState([]);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfError, setPdfError] = useState("");
    const dpi = 150;
    const [pdfCreateLoading, setPdfCreateLoading] = useState(false);
    const [pdfCreateError, setPdfCreateError] = useState("");
    const maxPages = 5;
    const [imageFormat, setImageFormat] = useState("png");

    const toolFav = {
        toolName: "PDF Image Converter",
        Iconpath: "/FileCodeRaw.svg"
    };

    

    

    const activeTab = "Image to PDF";
    const [files, setFiles] = useState([]);
    const inputRef = useRef(null);

    const isSupportedImage = (file) => {
        const supportedTypes = ["image/png", "image/jpeg"];
        const extension = file.name.split('.').pop().toLowerCase();
        const supportedExt = ["png", "jpg", "jpeg"];
        return supportedTypes.includes(file.type) || supportedExt.includes(extension);
    };

    const isSupportedPdf = (file) => {
        const extension = file.name.split('.').pop().toLowerCase();
        return file.type === "application/pdf" || extension === "pdf";
    };

    const clearUploads = () => {
        files.forEach((item) => {
            if (item.preview) {
                URL.revokeObjectURL(item.preview);
            }
        });
        setFiles([]);
        setPdfCreateError("");
        setPdfImages([]);
        
    };

    const handleFiles = (selectedFiles) => {
        const fileArray = Array.from(selectedFiles || []);
        const filteredFiles = selectedFormat === "Image ➜ PDF"
            ? fileArray.filter(isSupportedImage)
            : fileArray.filter(isSupportedPdf);

        const updated = filteredFiles.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));

        setFiles(updated);
        // Call API if PDF file is selected
        if (selectedFormat === "PDF ➜ Image") {
            handlePdfUpload(filteredFiles);
        }
    };

    const handleChange = (e) => {
        handleFiles(e.target.files);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result;
                const base64 = result.split(",")[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const handlePdfUpload = async (selectedFiles) => {
        const updated = Array.from(selectedFiles).map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));
        setFiles(updated);
        if (!selectedFiles?.length) return;
        try {
            setPdfLoading(true);
            setPdfError("");
            setPdfImages([]);
            const file = selectedFiles[0];
            const base64Pdf = await convertFileToBase64(file);
            const payload = {
                base64Pdf,
                maxPages,
                dpi,
                imageFormat,
            };
            const response = await PdftoImageAPI(payload);
            const formattedImages =
                response?.data.base64Images?.map((img, index) => ({
                    id: index,
                    src: `data:image/${response.data.imageFormat};base64,${img}`,
                })) || [];

            setPdfImages(formattedImages);
        } catch (error) {
            console.log(error);
            setPdfError("Failed to convert PDF to images");
        } finally {
            setPdfLoading(false);
        }
    };

    const handleCreatePdf = async () => {
        if (!files.length) return;

        try {
            setPdfCreateLoading(true);
            setPdfCreateError("");

            const base64Images = await Promise.all(
                files.map(({ file }) => convertFileToBase64(file))
            );

            const payload = {
                base64Images,
            };

            const response = await ImagetoPDFAPI(payload);
            const responseData = response?.data;
            const base64Pdf = responseData?.base64Pdf || "";

            if (!base64Pdf) {
                throw new Error("No PDF returned from API");
            }

            const pdfUrl = `data:application/pdf;base64,${base64Pdf}`;
            const fileName = `images-to-pdf.pdf`;

            const downloadLink = document.createElement("a");
            downloadLink.href = pdfUrl;
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        } catch (error) {
            console.error(error);
            setPdfCreateError("Failed to create PDF from images");
        } finally {
            setPdfCreateLoading(false);
        }
    };
    return (
        <Col>
            {/* HEADER */}
            <ToolHeader title="PDF Image Converter" description="Convert, merge, split, and compress in your browser" toolFav={toolFav} />

            {/* FORMAT TABS */}
            <Row>
                <div className="format-tabs">
                    {FORMAT_OPTIONS.map((item) => (
                        <button
                            key={item}
                            className={`format-btn ${selectedFormat === item
                                ? "active"
                                : ""
                                }`}
                            onClick={() => setSelectedFormat(item)}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </Row>

            <Row className='Formatter'>
                <div className="converter-wrapper">
                    {/* IMAGE ➜ BASE64 */}
                    {selectedFormat === "Image ➜ PDF" && (
                        <div className="imagepdf-container">
                            {/* Card */}
                            <div className="imagepdf-card">
                                <h3 className="imagepdf-title">
                                    {activeTab}
                                </h3>
                                <p className="imagepdf-subtitle">
                                    {activeTab === "Image to PDF"
                                        ? "Combine multiple images into a single PDF"
                                        : "Convert PDF pages into images"}
                                </p>
                            </div>
                            {/* Upload Area */}
                            <div
                                className="upload-zone"
                                onClick={() => inputRef.current.click()}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                            >
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    ref={inputRef}
                                    accept={
                                        activeTab === "Image to PDF"
                                            ? ".jpg,.jpeg,.png"
                                            : ".pdf"
                                    }
                                    onChange={handleChange}
                                />

                                <div className="upload-icon">
                                    <svg
                                        className="dmc-upload-icon"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M12 16V4M12 4L7 9M12 4L17 9" />
                                        <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                                    </svg>
                                </div>

                                <p className="upload-text">
                                    Click to select or drop{" "}
                                    {activeTab === "Image to PDF"
                                        ? "images"
                                        : "PDF"}{" "}
                                    here
                                </p>

                                <span className="upload-subtext">
                                    {activeTab === "Image to PDF"
                                        ? "Each image becomes one PDF page, in the order shown"
                                        : "Each PDF page will be converted into an image"}
                                </span>
                            </div>
                            {files.length>0  && (
                                <div className="pdf-create-section">
                                    <div>
                                        <span className="upload-subtext">
                                            {files.length} file loaded
                                        </span>
                                    </div>
                                    <div className="upload-buttons" style={{ marginLeft: "12px" }}>
                                        <button
                                            className="process-btn"
                                            onClick={handleCreatePdf}
                                            disabled={pdfCreateLoading}
                                        >
                                            <Download className="headerIcon" /> &nbsp;
                                            {pdfCreateLoading ? "Creating PDF..." : "Create PDF"}
                                        </button>
                                        <button
                                            className="clear-btn"
                                            onClick={clearUploads}
                                            disabled={!files.length}
                                            style={{ marginLeft: "12px" }}
                                        >
                                            <DeleteIcon className="heasderIcon" /> Clear
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Preview */}
                            {files.length > 0 && (
                                <>
                                    <div className="preview-grid">
                                        {files.map((item, index) => (
                                            <div key={index} className="pdf-preview-card">

                                                {activeTab === "Image to PDF" ? (
                                                    <img
                                                        src={item.preview}
                                                        alt="preview"
                                                        className="pdf-preview-image"
                                                    />
                                                ) : (
                                                    <div className="pdf-preview">
                                                        📄
                                                    </div>
                                                )}

                                                <div className="pdf-preview-name">
                                                    {item.file.name}
                                                </div>

                                            </div>
                                        ))}
                                    </div>



                                    {pdfCreateError && (
                                        <div className="pdf-error">
                                            {pdfCreateError}
                                        </div>
                                    )}

                                    {/* {pdfCreatedUrl && (
                                        <div className="pdf-created-card">
                                            <div className="pdf-created-header">
                                                <h4>PDF Created</h4>
                                                <a
                                                    href={pdfCreatedUrl}
                                                    download={pdfCreatedName}
                                                    className="download-btn"
                                                >
                                                    Download PDF
                                                </a>
                                            </div>
                                            <div className="pdf-created-details">
                                                <p>Total images converted: {pdfStats?.totalImagesConverted ?? "—"}</p>
                                                <p>Processing time: {pdfStats?.processingTimeMs ?? "—"} ms</p>
                                            </div>
                                        </div>
                                    )} */}
                                </>
                            )}
                        </div>
                    )}

                    {/* BASE64 ➜ IMAGE */}
                    {selectedFormat === "PDF ➜ Image" && (
                        <div className="imagepdf-container">

                            {/* CARD */}
                            <div className="imagepdf-card">

                                <h3 className="imagepdf-title">
                                    PDF to Image
                                </h3>

                                <p className="imagepdf-subtitle">
                                    Convert PDF pages into images
                                </p>
                            </div>
                            {/* OPTIONS */}
                            <div className="pdf-options-row">
                                {IMAGE_FORMATS.map((item) => (
                                    <button
                                        key={item}
                                        className={`format-btn ${imageFormat === item
                                            ? "active"
                                            : ""
                                            }`}
                                        onClick={() => setImageFormat(item)}
                                    >
                                        {item}
                                    </button>

                                ))}

                            </div>

                            {/* UPLOAD */}
                            <div
                                className="upload-zone"
                                onClick={() => inputRef.current.click()}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                            >

                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    ref={inputRef}
                                    accept=".pdf"
                                    onChange={handleChange}
                                />

                                <div className="upload-icon">
                                    <svg
                                        className="dmc-upload-icon"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M12 16V4M12 4L7 9M12 4L17 9" />
                                        <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
                                    </svg>
                                </div>

                                <p className="upload-text">
                                    Click to select or drop PDF here
                                </p>

                                <span className="upload-subtext">
                                    Each PDF page will be converted into an image
                                </span>

                            </div>

                            {files.length > 0  && (
                                <div className="pdf-create-section">
                                    <div>
                                        <span className="upload-subtext">
                                            {files.length} PDF file{files.length > 1 ? "s" : ""} loaded
                                        </span>
                                    </div>
                                    <div className="upload-buttons" style={{ marginLeft: "12px" }}>
                                        <button
                                            className="clear-btn"
                                            onClick={clearUploads}
                                            disabled={!files.length}
                                            style={{ marginLeft: "12px" }}
                                        >
                                            <DeleteIcon className="heasderIcon" /> Clear
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* LOADING */}
                            {pdfLoading && (
                                <div className="pdf-loading">
                                    Converting PDF to images...
                                </div>
                            )}

                            {/* ERROR */}
                            {pdfError && (
                                <div className="pdf-error">
                                    {pdfError}
                                </div>
                            )}
                            {/* IMAGE RESULTS */}
                            {pdfImages.length > 0 && (
                                <div className="preview-grid">
                                    {pdfImages.map((item, index) => (
                                        <div
                                            key={index}
                                            className="pdf-preview-card"
                                        >
                                            <img
                                                src={item.src}
                                                alt={`page-${index}`}
                                                className="pdf-preview-image"
                                            />

                                            <div className="preview-name">
                                                Page {index + 1}
                                            </div>

                                            <a
                                                href={item.src}
                                                download={`page-${index + 1}.${imageFormat}`}
                                                className="download-btn"
                                            >
                                                Download
                                            </a>

                                        </div>

                                    ))}

                                </div>

                            )}

                        </div>
                    )}
                </div>
            </Row>

        </Col>
    );
}

export default PDFImageConverter;

